import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const VerificationResponseSchema = z
  .object({
    data: z.object({
      user_id: z.number().or(z.null()),
      applicant_token: z.string().or(z.null()),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TVerificationResponse = z.infer<typeof VerificationResponseSchema>;
export type TVerificationData = z.infer<typeof VerificationResponseSchema>['data'];
